import axios    from 'axios';

/* Constants */
import {ERROR_STATUS} from "../constants";

export default class ServiceAxios {

    constructor (ambient) {
        this.ambient  = ambient;

        if(typeof ServiceAxios.instance === "object"){
            return ServiceAxios.instance;
        }

        ServiceAxios.instance = this;
        return this;
    }

    async executeService(urlService, methodService, responseTypeService = '', bodyService = {}, headerService = {}){

        try {
            const responseRest = await axios({
              url:          urlService,
              method:       methodService,
              responseType: responseTypeService,
              data:         bodyService,
              headers:      headerService,
            });
            return responseRest; 
        } catch (error) {
            let code = 'error_faild';
            const errorMessage = error || error.message || 'Error desconocido';
            console.log('messages error', errorMessage);
            if(String(errorMessage) === "Network Error") {
                code = ERROR_STATUS[2136];
            } else if(String(errorMessage.message) === "Error: Request failed with status code 400") {
                code = ERROR_STATUS[400];
            } else if(String(errorMessage.message) === "Request failed with status code 403") {
                console.log('403 error');
                code = ERROR_STATUS[403];
            } else if(String(errorMessage.message) === "Error: Request failed with status code 404") {
                code = ERROR_STATUS[404];
            } else if(String(errorMessage.message) === "Error: Request failed with status code 409") {
                code = ERROR_STATUS[409];
            }
            return code;
        }

    }

    /**
     * Igual que executeService pero, ante error, conserva el status HTTP y el mensaje del backend
     * (p. ej. el 409 del candado de cesión de cartera) en lugar de reducirlo a un código de texto.
     * Error: { esError: true, status: number|null, mensaje: string|null, esErrorRed: boolean }.
     */
    async executeServiceDetallado(urlService, methodService, bodyService = {}, headerService = {}) {
        try {
            return await axios({ url: urlService, method: methodService, data: bodyService, headers: headerService });
        } catch (error) {
            const respuesta = error?.response;
            console.error(`Error al consumir ${methodService} ${urlService}`, error);
            return {
                esError: true,
                status: respuesta?.status ?? null,
                mensaje: ServiceAxios.extraerMensajeError(respuesta?.data),
                esErrorRed: !respuesta,
            };
        }
    }

    // El backend (GeneralResponse de ms-cobranza) responde { code, message, response }; a veces llega como texto JSON.
    static extraerMensajeError(data) {
        let cuerpo = data;
        if (typeof cuerpo === 'string') {
            try {
                cuerpo = JSON.parse(cuerpo);
            } catch (error) {
                return cuerpo.trim() || null;
            }
        }
        const mensaje = cuerpo?.message ?? cuerpo?.mensaje ?? null;
        return typeof mensaje === 'string' && mensaje.trim() ? mensaje.trim() : null;
    }

    async serviceRest(method, url, data) {
        try {
            const responseRest = await axios({ url, method, data });
            return responseRest; 
        } catch (error) {
            let code = 'error_faild';
            const errorMessage =  error || error.message || 'Error desconocido';
            if(String(errorMessage) === "Network Error") {
                code = ERROR_STATUS[2136];
            } else if(String(errorMessage) === "Error: Request failed with status code 400") {
                code = ERROR_STATUS[400];
            } else if(String(errorMessage) === "Error: Request failed with status code 404") {
                code = ERROR_STATUS[404];
            } else if(String(errorMessage) === "Error: Request failed with status code 409") {
                code = ERROR_STATUS[409];
            }
            return code;
        }
    }

    async serviceDocuments(verb, endpoint, bodyRaw, headers){
        try {
            const responseRest = await axios({
              url:          endpoint,
              method:       verb,
              responseType: "blob",
              data:         bodyRaw,
              headers:      headers
            });
            return responseRest; 
        } catch (error) {
            let code = 'error_faild';
            const errorMessage =  error || error.message || 'Error desconocido';
            if(String(errorMessage) === "Network Error"){
                code = ERROR_STATUS[2136];
            }else if(String(errorMessage) === "Error: Request failed with status code 404"){
                code = ERROR_STATUS[404];
            }else{
                code = ERROR_STATUS[500]
            }
            return code;
        }
    }

    async serviceRestHeaders(verb, endpoint, bodyRaw = {},  headers = {}){
        try {
            const responseRest = await axios({
              url:     endpoint,
              method:  verb,
              data:    bodyRaw,
              headers: headers
            });
            return responseRest; 
        } catch (error) {
            //console.log(error)
            //console.log(error.message)
            var code = 'error_faild';
            /// Error network
            if(String(error.message) === "Network Error"){
                code = ERROR_STATUS[2136];
            }else if(String(error.message) === "Request failed with status code 404"){
                code = ERROR_STATUS[404];
            }else{

            }
            return code;
        }
    }

}